import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '../buttons/Button';
import { Widget } from '../widget/Widget';

import styles from './TableSidebarWidget.module.scss';

export type TableSidebarWidgetProps = {
  onClose: () => void;
  content?: React.ReactNode;
};

export function TableSidebarWidget({
  content,
  onClose,
}: TableSidebarWidgetProps) {
  const { t } = useTranslation();

  const closeAction = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Widget
      title={t('app.tableSidebarWidget.widgetTitle')}
      actions={[
        {
          icon: { name: 'close' },
          cb: closeAction,
          title: t('app.tableSidebarWidget.closeSidebar'),
        },
      ]}
    >
      <div className={styles['content']}>{content}</div>
    </Widget>
  );
}

export function ActionButtons({ buttons }: { buttons: ButtonProps[] }) {
  return (
    <div className={styles['action-buttons']}>
      {buttons.map((button) => (
        <Button key={button.title} {...button}>
          {button.title}
        </Button>
      ))}
    </div>
  );
}
